import { OrganizationKeyName } from "../../../model/Organization";
import { NewsListItem } from "../model/NewsListSuccessResponse";

export const GET_NEWS_LIST_SUCCESS = "SHOP:GET_NEWS_LIST_SUCCESS";

export const getNewsListSuccessAction = (
  organization: OrganizationKeyName,
  data: NewsListItem[]
) => ({
  type: GET_NEWS_LIST_SUCCESS as typeof GET_NEWS_LIST_SUCCESS,
  organization,
  data,
});

export type GetNewsListSuccessAction = ReturnType<
  typeof getNewsListSuccessAction
>;
